import { Types } from '@tribeplatform/gql-client';
import { useRouter } from '@tribeplatform/react-sdk';
import { useAuthToken, useSpaceUtil, SystemSpaceSlug, } from '@tribeplatform/react-sdk/hooks';
export const useLogin = () => {
    var _a, _b;
    const { data: authToken } = useAuthToken();
    const isGuest = !((_a = authToken === null || authToken === void 0 ? void 0 : authToken.role) === null || _a === void 0 ? void 0 : _a.type) || ((_b = authToken === null || authToken === void 0 ? void 0 : authToken.role) === null || _b === void 0 ? void 0 : _b.type) === Types.RoleType.guest;
    const { push, replace } = useRouter();
    const { generatePath } = useSpaceUtil();
    const showLogin = (replacePath = false) => {
        var _a;
        if (!isGuest)
            return false;
        const path = generatePath(SystemSpaceSlug.LOGIN, null, ((_a = window.location) === null || _a === void 0 ? void 0 : _a.pathname)
            ? { redirect: encodeURIComponent(window.location.pathname) }
            : null);
        if (replacePath)
            replace(path);
        else
            push(path);
    };
    const isLoggedIn = !isGuest;
    return {
        showLogin,
        isLoggedIn,
    };
};
//# sourceMappingURL=useLogin.js.map